console.log('check');
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		// Optional
		loadProductFirst: false,
		// paginationType: boostPFSConfig.custom.pagination_type == 'infinite_scroll' ? 'infinite' :
		// 	(boostPFSConfig.custom.pagination_type == 'load_more' ? 'load_more' : 'default'),
		filterTreeMobileStyle: 'style1'
	},
	template: {
		loadMoreLoading: '<div class="boost-pfs-filter-load-more-loading"><div class="load-more__icon" style="width: 44px; height: 44px; opacity: 1;"></div></div>',
	},
	selector: {
		breadcrumb: '.breadcrumb-collection'
	}
};

// Declare Templates
var boostPFSTemplate = {
	'saleLabelHtml': '<div class="sale_banner thumbnail_banner">' + boostPFSConfig.label.sale + '</div>',
	'newLabelHtml': '<div class="new_banner thumbnail_banner">' + boostPFSConfig.label.new + '</div>',
	'preorderLabelHtml': '<div class="new_banner thumbnail_banner">' + boostPFSConfig.label.pre_order + '</div>',
	'quickViewBtnHtml': '<span data-fancybox-href="#product-{{itemId}}" class="quick_shop ss-icon" data-gallery="product-{{itemId}}-gallery">&#x002B;</span>',
	'newRowHtml': '<br class="clear product_clear" />',

	// Grid Template
	'productGridItemHtml': 	'<div class="{{itemColumnNumberClass}} {{itemCollectionGroupThumbClass}} thumbnail {{itemCollectionGroupSmallClass}} quick-shop-style--'+ boostPFSConfig.custom.quick_shop_style +' product-{{itemId}}" data-boost-theme-quickview="{{itemId}}">' +
									'<div class="product-wrap {{flipImageClass}} ">' +
										'<div class="relative product_image swap-' + boostPFSConfig.custom.secondary_image + '">' +
											'<a href="{{itemUrl}}">' +
												'{{itemImages}}' +
												'{{itemWishlist}}' +
												'{{itemColorSwatchesInline}}' +
												'{{itemProductInfoHover}}' +
												'<div class="banner_holder">' +
													'{{itemSaleLabel}}' +
													'{{itemNewLabel}}' +
													'{{itemPreorderLabel}}' +
												'</div>' +
												'<div class="custom-quickbuy"> {{itemProductQuickBuy}} </div>' +
											'</a>' +
										'</div>' +
										'<a class="product-info__caption {{itemHiddenClass}}" href="{{itemUrl}}">' +
											'{{itemProductInfo}}' +
											'{{itemMoreColorsAvailable}}' +
										'</a>' +
									'</div>' +
									'{{itemColorSwatchesPopup}}' +
									'<div class="custom-quickbuy custom-quickbuy--mobile"><div class="custom-quickbuy__background"></div>{{itemProductQuickBuyMobile}} </div>' +
								'</div>',


	// Pagination Template
	'previousHtml': '<span class="prev"><a href="{{itemUrl}}">« ' + boostPFSConfig.label.paginate_prev + '</a></span>',
	'nextHtml': '<span class="next"><a href="{{itemUrl}}">' + boostPFSConfig.label.paginate_next + ' »</a></span>',
	'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
	'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
	'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
	'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

	// Sorting Template
	'sortingHtml': '{{sortingItems}}',
};


(function () { // Add this
	BoostPFS.inject(this); // Add this

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data, index) {
		if(!data) data = this.data;
		if (!index) index = this.index + 1;

		/*** Prepare data ***/
		var images = data.images_info;
		if (images.length > 0) {
		data.featured_image = images[0];
		} else {
			data.featured_image = {
				'height': 1,
				'width': 1
			}
		}
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		var onSaleClass = onSale ? 'sale' : '';
		var soldOutClass = soldOut ? 'out_of_stock' : 'in_stock';
		var availabilityProp = soldOut ? 'http://schema.org/SoldOut' : 'http://schema.org/InStock';

		// Add custom class
		var itemColumnNumberClass = '';
		var itemCollectionGroupThumbClass = buildItemCollectionGroupThumbClass(index, boostPFSConfig.custom.products_per_row);
		var itemCollectionGroupLargeClass = '';
		var itemCollectionGroupMediumClass = '';
		var itemCollectionGroupSmallClass = (index - 1) % 2 == 0 ? 'even' : 'odd';

		switch (boostPFSConfig.custom.products_per_row) {
			case 2:
				itemColumnNumberClass = 'eight columns';
				break;
			case 3:
				itemColumnNumberClass = 'one-third column';
				break;
			case 4:
				itemColumnNumberClass = 'four columns';
				break;
			case 5:
				itemColumnNumberClass = 'one-fifth column';
				break;
			case 6:
				itemColumnNumberClass = 'one-sixth column';
				break;
			default:
				itemColumnNumberClass = 'one-seventh column';
				break;
		}

		if (boostPFSConfig.custom.mobile_products_per_row == 1) {
			itemColumnNumberClass += ' medium-down--one-half small-down--one-whole';
		} else {
			itemColumnNumberClass += ' medium-down--one-half small-down--one-half';
		}

		itemHtml = itemHtml.replace(/{{itemColumnNumberClass}}/g, itemColumnNumberClass);
		itemHtml = itemHtml.replace(/{{itemCollectionGroupThumbClass}}/g, itemCollectionGroupThumbClass);
		itemHtml = itemHtml.replace(/{{itemCollectionGroupLargeClass}}/g, itemCollectionGroupLargeClass);
		itemHtml = itemHtml.replace(/{{itemCollectionGroupMediumClass}}/g, itemCollectionGroupMediumClass);
		itemHtml = itemHtml.replace(/{{itemCollectionGroupSmallClass}}/g, itemCollectionGroupSmallClass);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		// Add onSale label
		var itemSaleLabel = boostPFSConfig.custom.sale_banner_enabled && onSale ? boostPFSTemplate.saleLabelHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

		// Add Label (New, Coming soon, Pre order)
		var newLabel = data.collections.filter(function (e) {
			return e.handle == 'new';
		});
		var preorderLabel = data.collections.filter(function (e) {
			return e.handle == 'pre-order';
		});
		var comingsoonLabel = data.collections.filter(function (e) {
			return e.handle == 'coming-soon';
		});
		if (data.collections) {
			var itemNewLabelHtml = typeof newLabel[0] != 'undefined' ? boostPFSTemplate.newLabelHtml : '';
			itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);

			var itemComingsoonLabelHtml = typeof comingsoonLabel[0] != 'undefined' ? boostPFSTemplate.comingsoonLabelHtml : '';
			itemHtml = itemHtml.replace(/{{itemComingsoonLabel}}/g, itemComingsoonLabelHtml);

			var itemPreorderLabelHtml = typeof preorderLabel[0] != 'undefined' ? boostPFSTemplate.preorderLabelHtml : '';
			itemHtml = itemHtml.replace(/{{itemPreorderLabel}}/g, itemPreorderLabelHtml);
		}

		var itemHiddenClass = boostPFSConfig.custom.thumbnail_hover_enabled ? 'hidden' : '';
		itemHtml = itemHtml.replace(/{{itemHiddenClass}}/g, itemHiddenClass);

		var flipImageClass = boostPFSConfig.custom.secondary_image && images.length > 1 ? 'has-secondary-media-swap' : '';
		itemHtml = itemHtml.replace(/{{flipImageClass}}/ , flipImageClass)
		// Get image source
		var itemImageSrc = 'src="' + Utils.getFeaturedImage(images, '300x') + '" ';
		itemImageSrc += 'srcset=" ' + Utils.getFeaturedImage(images, '200x') + ' 200w,';
		itemImageSrc += Utils.getFeaturedImage(images, '300x') + ' 300w,';
		itemImageSrc += '"';
		// Get Thumbnail url
		var itemThumbUrl = Utils.getFeaturedImage(images, boostPFSConfig.custom.image_loading_style == 'blur-up' ? '50x' : '100x');
		// Get Flip image url
		var itemFlipImageUrl = images.length > 1 ? Utils.optimizeImage(images[1]['src']) : Utils.getFeaturedImage(images, '900x');

		// Add Thumbnail
		var product_set_width = data.featured_image.width;
		var align_height_value = '';
		if (boostPFSConfig.custom.align_height) {
			if (images.length > 0) {
				var collection_height = boostPFSConfig.custom.collection_height;
				var product_aspect_ratio = images[0]['width'] / images[0]['height'];
				product_set_width = product_aspect_ratio * collection_height;
				if (images[0]['width'] >= images[0]['height']) {
					align_height_value = 'width: 100%; height: auto;';
				} else {
					align_height_value = 'width: 100%;';
				}
			}
		}
		var backgroundColor = '';
		if (boostPFSConfig.custom.image_loading_style == 'color') {
			var dominantColorImage = Utils.getFeaturedImage(images, '1x');
			backgroundColor = 'background: url(' + dominantColorImage + ')';
		}
		var itemImagesHtml = '<div class="image__container">';
		itemImagesHtml += '<div class="image-element__wrap" style="width: ' + product_set_width + 'px; ' + backgroundColor + '">';
		itemImagesHtml += '<img ' +
							' alt="{{itemTitle}}" ' +
							' class=""' +
							' style="' + align_height_value + 'max-width: ' + data.featured_image.width + 'px;"' +
							' ' + itemImageSrc + '/>';
		itemImagesHtml += '</div>';
		itemImagesHtml += '</div>';
		// Add Flip Image
		if (boostPFSConfig.custom.secondary_image && images.length > 1) {
			// Get image source
			var itemFlipImageSrc = 'src="' + Utils.optimizeImage(images[1]['src'], '300x') + '" ';
			itemFlipImageSrc += 'srcset=" ' + Utils.optimizeImage(images[1]['src'], '200x')  + ' 200w, ';
			itemFlipImageSrc += Utils.optimizeImage(images[1]['src'], '300x')  + ' 300w, ';
			itemFlipImageSrc += '"';
				itemImagesHtml += '<div class="image__container">';
				itemImagesHtml += '<div class="image-element__wrap" style="width:';
				if (images.length > 1) {
					itemImagesHtml += images[1]['width'] + 'px">';
				} else {
					itemImagesHtml += data.featured_image.width + 'px">';
				}
				itemImagesHtml += '<img ';
				itemImagesHtml += 'class="" alt="{{itemTitle}}" ' + itemFlipImageSrc + '/>'
				itemImagesHtml += '</div>';
				itemImagesHtml += '</div>';
		}

		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Build Product Info when hovering
		var itemProductInfoHoverHtml = '';
		if ((boostPFSConfig.custom.thumbnail_hover_enabled || boostPFSConfig.custom.quick_shop_enabled) && boostPFSConfig.custom.quick_shop_style == 'popup') {
			itemProductInfoHoverHtml = '<div class="thumbnail-overlay">' +
				'<a href="{{itemUrl}}" class="hidden-product-link">{{itemTitle}}</a>' +
				'<div class="info">' +
				(boostPFSConfig.custom.thumbnail_hover_enabled ? '{{itemProductInfo}}' : '') +
				'</div>' +
				'</div>';
		}
		itemHtml = itemHtml.replace(/{{itemProductInfoHover}}/g, itemProductInfoHoverHtml);

		// Build Product Info (product-info.liquid)
		var itemProductInfoHtml = '<div class="product-details">';
		itemProductInfoHtml += '{{itemVendor}}';
		itemProductInfoHtml += '<span class="title">{{itemTitle}}</span>';
		itemProductInfoHtml += '{{itemReview}}';
		itemProductInfoHtml += '{{itemPrice}}';
		itemProductInfoHtml += '</div>';
		itemHtml = itemHtml.replace(/{{itemProductInfo}}/g, itemProductInfoHtml);

		// Add Review badge
		var itemReviewHtml = '';
		if (boostPFSConfig.custom.enable_shopify_review_comments && boostPFSConfig.custom.enable_shopify_collection_badges) {
			itemReviewHtml = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		}
		itemHtml = itemHtml.replace(/{{itemReview}}/g, itemReviewHtml);

		// Add Vendor
		var itemVendorHtml = '';
		if (boostPFSConfig.custom.vendor_enable) {
			itemVendorHtml = '<span class="brand">' + data.vendor + '</span>';
		}
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = '';
		if (typeof comingsoonLabel[0] !== 'undefined') {
			itemPriceHtml += '<span class="modal_price">' + boostPFSConfig.label.coming_soon + '</span>';
		} else {
			itemPriceHtml += '<span class="price ' + onSaleClass + '">';
			if (!soldOut) {
				if (priceVaries && data.price_min > 0) {
					itemPriceHtml += '<small><em>' + boostPFSConfig.label.from_price + '</em></small> ';
				}
				if (data.price_min > 0) {
					itemPriceHtml += '<span class="money">' + Utils.formatMoney(data.price_min) + '</span>';
				} else {
					itemPriceHtml += boostPFSConfig.label.free_price;
				}
			} else {
				itemPriceHtml += '<span class="sold_out">' + boostPFSConfig.label.sold_out + '</span>';
			}
			if (onSale) {
				itemPriceHtml += ' <span class="was_price"><span class="money">' + Utils.formatMoney(data.compare_at_price_max) + '</span></span>';
			}
			itemPriceHtml += '</span>';
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		
		var moreColorsVariants = data['tags'].toString().indexOf('e:style_code:') !== -1;
		var itemMoreColors = '';
		if(moreColorsVariants) {
			itemMoreColors += '<div class="more-colors-available">+ More colours available</div>';
		}
		itemHtml = itemHtml.replace(/{{itemMoreColorsAvailable}}/g, itemMoreColors);

		// Add Swatches
		var itemColorSwatchesHtml = '';
		if (boostPFSConfig.custom.collection_swatches) {
			for (var k = 0; k < data.options.length; k++) {
				var option = data['options'][k];
				var downcasedOption = option.toLowerCase();
				var colorTypes = ['color', 'colour', 'farve'];
				if (colorTypes.indexOf(downcasedOption) > -1) {
					var option_index = k;
					var values = [];
					itemColorSwatchesHtml += '<div class="collection_swatches">';
					for (var i = 0; i < data.variants.length; i++) {
						var variant = data['variants'][i];
						var value = variant['options'][option_index];
						if (values.indexOf(value) == -1) {
							var values = values.join(',');
							values += ',' + value;
							values = values.split(',');
							var fileColorUrl = boostPFSConfig.general.asset_url.replace('boost-pfs-filter.js', Utils.slugify(value) + '.png');
							fileColorUrl = Utils.optimizeImage(fileColorUrl, '50x');
							itemColorSwatchesHtml += '<a href="' + Utils.buildProductItemUrl(data) + '?variant=' + variant.id + '" class="swatch" data-swatch-name="meta-' + downcasedOption + '_' + (value.replace(/\s/g, '_')).toLowerCase() + '">';
							itemColorSwatchesHtml += '<span ';
							if (boostPFSConfig.custom.products_per_row == 2) {
								itemColorSwatchesHtml += 'data-image="' + Utils.optimizeImage(variant.image, '600x') + '" ';
							} else if (boostPFSConfig.custom.products_per_row == 2) {
								itemColorSwatchesHtml += 'data-image="' + Utils.optimizeImage(variant.image, '500x') + '" ';
							} else {
								itemColorSwatchesHtml += 'data-image="' + Utils.optimizeImage(variant.image, '400x') + '" ';
							}
							itemColorSwatchesHtml += 'style="background-image: url(' + fileColorUrl + '); background-color: ' + Utils.slugify(value.split(' ').pop()) + ';">';
							itemColorSwatchesHtml += '</span>';
							itemColorSwatchesHtml += '</a>';
						}
					}
					itemColorSwatchesHtml += '</div>';
				}
			}
		}
		if (boostPFSConfig.custom.quick_shop_style == 'inline') {
			itemHtml = itemHtml.replace(/{{itemColorSwatchesInline}}/g, itemColorSwatchesHtml);
			itemHtml = itemHtml.replace(/{{itemColorSwatchesPopup}}/g, '');
		} else if (boostPFSConfig.custom.quick_shop_style == 'popup' && boostPFSConfig.custom.quick_shop_enabled) {
			itemHtml = itemHtml.replace(/{{itemColorSwatchesInline}}/g, '');
			itemHtml = itemHtml.replace(/{{itemColorSwatchesPopup}}/g, itemColorSwatchesHtml);
		} else {
			itemHtml = itemHtml.replace(/{{itemColorSwatchesInline}}/g, '');
			itemHtml = itemHtml.replace(/{{itemColorSwatchesPopup}}/g, '');
		}

		/* Swym integration */
		var itemWishlistHtml = '<button class="swym-button swym-add-to-wishlist-view-product product_{{itemId}}" data-swaction="addToWishlist"  data-product-id="' + JSON.stringify(data.id) + '">';
		itemWishlistHtml += '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><g clip-path="url(#clip0_2769_10972)"><path d="M9.99998 18.8873C9.71525 18.8873 9.44075 18.7841 9.22682 18.5968C8.41887 17.8903 7.63991 17.2264 6.95265 16.6407L6.94914 16.6377C4.93423 14.9206 3.19427 13.4378 1.98364 11.9771C0.630339 10.3441 0 8.79576 0 7.10433C0 5.46096 0.563506 3.94485 1.58661 2.83508C2.62191 1.71219 4.0425 1.09375 5.58715 1.09375C6.74163 1.09375 7.7989 1.45874 8.72954 2.1785C9.1992 2.54181 9.62492 2.98645 9.99998 3.50509C10.3752 2.98645 10.8008 2.54181 11.2706 2.1785C12.2012 1.45874 13.2585 1.09375 14.413 1.09375C15.9575 1.09375 17.3782 1.71219 18.4135 2.83508C19.4366 3.94485 20 5.46096 20 7.10433C20 8.79576 19.3698 10.3441 18.0165 11.9769C16.8058 13.4378 15.066 14.9205 13.0514 16.6374C12.363 17.2239 11.5828 17.8889 10.773 18.5971C10.5592 18.7841 10.2846 18.8873 9.99998 18.8873ZM5.58715 2.26532C4.37362 2.26532 3.25881 2.74963 2.44781 3.62915C1.62475 4.52194 1.17141 5.75606 1.17141 7.10433C1.17141 8.5269 1.70013 9.79918 2.88558 11.2295C4.03136 12.6121 5.73562 14.0645 7.70888 15.7461L7.71254 15.7492C8.40239 16.3371 9.1844 17.0036 9.9983 17.7153C10.8171 17.0022 11.6003 16.3347 12.2915 15.7458C14.2647 14.0642 15.9688 12.6121 17.1145 11.2295C18.2998 9.79918 18.8285 8.5269 18.8285 7.10433C18.8285 5.75606 18.3752 4.52194 17.5522 3.62915C16.7413 2.74963 15.6263 2.26532 14.413 2.26532C13.524 2.26532 12.7078 2.54791 11.9871 3.10516C11.3449 3.60199 10.8975 4.23004 10.6352 4.66949C10.5003 4.89547 10.2629 5.03036 9.99998 5.03036C9.73707 5.03036 9.49965 4.89547 9.36476 4.66949C9.10261 4.23004 8.65523 3.60199 8.01283 3.10516C7.29216 2.54791 6.47597 2.26532 5.58715 2.26532Z" fill="black"/></g><defs><clipPath id="clip0_2769_10972"><rect width="20" height="20" fill="white"/></clipPath></defs></svg>';
		itemWishlistHtml += '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 15 16" fill="none"><g clip-path="url(#clip0_2676_9937)"><path d="M15 5.57814C15 6.84649 14.5274 8.00806 13.5125 9.23247C12.6044 10.3281 11.2997 11.4401 9.78848 12.7278C9.27212 13.1677 8.68698 13.6665 8.07987 14.1977C7.9208 14.3369 7.71698 14.4141 7.50526 14.4154H7.5C7.28645 14.4154 7.08057 14.338 6.92013 14.1975C6.31416 13.6676 5.72994 13.1695 5.2145 12.7301L5.21187 12.7282C3.7009 11.4404 2.39559 10.3281 1.48773 9.23247C0.472641 8.00806 0 6.84649 0 5.57814C0 4.34573 0.42263 3.20853 1.18996 2.3762C1.96655 1.53391 3.032 1.07031 4.19037 1.07031C5.05634 1.07031 5.84908 1.34383 6.54728 1.88364C6.89964 2.15624 7.21882 2.48949 7.5 2.87871L7.50526 2.87173C7.7853 2.48549 8.10276 2.15453 8.45295 1.88364C9.15092 1.34383 9.944 1.07031 10.8096 1.07031C11.9682 1.07031 13.0337 1.53391 13.81 2.3762C14.5774 3.20853 15 4.34538 15 5.57814Z" fill="#FFA792"/><path d="M15.0006 5.57814C15.0006 6.84649 14.528 8.00806 13.5131 9.23247C12.605 10.3281 11.3003 11.4401 9.78907 12.7278C9.27271 13.1677 8.68758 13.6665 8.08047 14.1977C7.92139 14.3369 7.71758 14.4141 7.50586 14.4154V2.87173C7.7859 2.48549 8.10336 2.15453 8.45354 1.88364C9.15152 1.34383 9.9446 1.07031 10.8102 1.07031C11.9688 1.07031 13.0343 1.53391 13.8106 2.3762C14.578 3.20853 15.0006 4.34538 15.0006 5.57814Z" fill="#FFA792"/></g><defs><clipPath id="clip0_2676_9937"><rect width="15" height="15" fill="white" transform="translate(0 0.25)"/></clipPath></defs></svg>';
		itemWishlistHtml += '</button>';

		itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);

		let itemProductQuickBuy = '';
		const quickbuyDropdown = data['tags'].toString().indexOf('PLP-dropdown') !== -1;
		const quickbuyDropdownTrainers = data['product_type'].toString().toLowerCase().indexOf("trainers") !== -1;
		const quickbuyDropdownJeans = data['product_type'].toString().toLowerCase().indexOf("jeans") !== -1;
		const quickbuyDropdownCasualShoes = data['product_type'].toString().toLowerCase().indexOf("casual shoes") !== -1;
		const quickbuyDropdownSandals = data['product_type'].toString().toLowerCase().indexOf("sandals & slides") !== -1;

		if(data.variants.length > 1) {
			let quickBuySVG = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1V13" stroke="white" stroke-width="0.96" stroke-linecap="round"/><path d="M1 7L13 7" stroke="white" stroke-width="0.96" stroke-linecap="round"/></svg>';
			itemProductQuickBuy += '<form method="post" action="/cart/add" id="product_form_'+ data.id +'" accept-charset="UTF-8" class="shopify-product-form ';
			if(quickbuyDropdown || quickbuyDropdownTrainers || quickbuyDropdownJeans || quickbuyDropdownCasualShoes || quickbuyDropdownSandals) {
				itemProductQuickBuy += ' quickbuy--dropdown" enctype="multipart/form-data">';
			} else {
				itemProductQuickBuy += '" enctype="multipart/form-data">';
			}

			itemProductQuickBuy += '<input type="hidden" name="id" data-productid="" class="product-select" value=""/>';
			itemProductQuickBuy += '<div class="custom-quickbuy__wrapper">';
			itemProductQuickBuy += '<button type="button" name="add" class=" ajax-submit action_button add_to_cart" data-label="Add to Bag">Add to Bag</button>';
			itemProductQuickBuy += '<button type="button" class="custom-quickbuy__btn">'+ quickBuySVG +'Quick Add</button>';
			itemProductQuickBuy += '</div>';
			itemProductQuickBuy += '<div class="custom-quickbuy__list">';
			itemProductQuickBuy += '<h3 class="custom-quickbuy__vendor">' + data.vendor + '</h3>';
			itemProductQuickBuy += '<div class="custom-quickbuy__title-wrapper">';
			itemProductQuickBuy += '<p class="custom-quickbuy__title">' + data.title + '</p>';
			itemProductQuickBuy += '<button type="button" data-url="' + Utils.buildProductItemUrl(data) + '">View Details</button>';
			itemProductQuickBuy += '</div>';
			itemProductQuickBuy += '<div class="custom-quickbuy__header">';
			itemProductQuickBuy += '<span>Select Size</span>';
			itemProductQuickBuy += '<button class="custom-quickbuy__close" type="button">';
			itemProductQuickBuy += '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M13.5636 12.6082L8.06512 7.10969L13.5636 1.61118C13.8448 1.32999 13.8448 0.87412 13.5636 0.592932C13.2824 0.311744 12.8266 0.311744 12.5454 0.592932L7.04688 6.09145L1.54836 0.592932C1.26717 0.311744 0.811303 0.311744 0.530115 0.592932C0.248927 0.87412 0.248927 1.32999 0.530115 1.61118L6.02863 7.10969L0.530115 12.6082C0.248927 12.8894 0.248927 13.3453 0.530115 13.6265C0.811303 13.9076 1.26717 13.9076 1.54836 13.6265L7.04688 8.12794L12.5454 13.6265C12.8266 13.9076 13.2824 13.9076 13.5636 13.6265C13.8448 13.3453 13.8448 12.8894 13.5636 12.6082Z" fill="black"/></svg>';
			itemProductQuickBuy += '</button>';
			itemProductQuickBuy += '</div>';
			itemProductQuickBuy += '<ul>';
			for (var i = 0; i < data.variants.length; i++) {
				var variant = data['variants'][i];
				let disableSize = '';
				if(!variant.available) { 
					disableSize = 'disabled';
				}
				itemProductQuickBuy += '<li data-product="' + data.id + '" data-variant="' + variant.id + '">';
				itemProductQuickBuy += '<button type="button" class="custom-quickbuy__size"'+ disableSize +'>' + variant.title + '</button>';
				itemProductQuickBuy += '</li>';
			}
			itemProductQuickBuy += '</ul>';
			itemProductQuickBuy += '</div>';
			itemProductQuickBuy += '</form>';
		} else {
			if(data.available) {
				itemProductQuickBuy += '<form method="post" action="/cart/add" id="product_form_'+ data.id +'" accept-charset="UTF-8" class="shopify-product-form '+ quickbuyDropdown +'" enctype="multipart/form-data">';
				for (var i = 0; i < data.variants.length; i++) {
					var variant = data['variants'][i];
					let disableSize = '';
					if(!variant.available) { 
						disableSize = 'disabled';
					} else {
						itemProductQuickBuy += '<input type="hidden" name="id" data-productid="' + data.id + '" class="product-select" value="' + variant.id + '"/>';
					}
				}
				itemProductQuickBuy += '<div class="custom-quickbuy__wrapper">';
				itemProductQuickBuy += '<button type="button" name="add" class=" ajax-submit action_button add_to_cart" data-label="Add to Bag" style="display:block">Add to Bag</button>';
				itemProductQuickBuy += '</div>';
				itemProductQuickBuy += '</form>';
			}
		}
		itemHtml = itemHtml.replace(/{{itemProductQuickBuy}}/g, itemProductQuickBuy);
		itemHtml = itemHtml.replace(/{{itemProductQuickBuyMobile}}/g, itemProductQuickBuy);
		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	};

	// Build advanced class
	function buildItemCollectionGroupThumbClass(index, productsPerRow) {
		var temp = index < productsPerRow ? index : index % productsPerRow;
		if (temp == 0) {
			return 'omega';
		} else if (temp == 1) {
			return 'alpha';
		}
		return '';
	}

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		// Get page info
      	if (!totalProduct) totalProduct = this.totalProduct;
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (Settings.getSettingValue('general.paginationType') == 'default' && totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousHtml : '';
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextHtml : '';
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}
		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {

			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);

				return html;
			}
		}
		return '';
	};

	// Sorting render
	ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());
		var $selectInput = jQ(Selector.topSorting);
		if ($selectInput.length) {
		$selectInput.val(Globals.queryParams.sort);
		}
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function () {
		var _this = this;
		jQ(Selector.topSorting).change(function (e) {
			// Append "sort" param to url
			// Used to Scroll to the previous position after returning from Product page
			FilterApi.setParam('sort', jQ(this).val());
			FilterApi.applyFilter('sort');
		})
	};

	// Build Breadcrumb
	Breadcrumb.prototype.compileTemplate = function (colData, apiData) {
		if (!colData) colData = this.collectionData;
		if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
			var colInfo = colData.collection;

			var breadcrumbHtml = '<span ><a href="' + boostPFSConfig.shop.url + '" title="' + boostPFSConfig.shop.name + '" class="breadcrumb_link"><span>' + boostPFSConfig.label.breadcrumb_home + '</span></a></span> ';
			breadcrumbHtml += '<span class="breadcrumb-divider">/</span> ' +
				'<span><a href="{{currentCollectionLink}}" title="{{currentCollectionTitle}}" class="breadcrumb_link"><span>{{currentCollectionTitle}}</span></a></span> ';
			// Build Tags
			var currentTagsHtml = '';
			if (Array.isArray(boostPFSConfig.general.current_tags)) {
				var current_tags = boostPFSConfig.general.current_tags;
				for (var k = 0; k < current_tags.length; k++) {
					var tag = current_tags[k];
					currentTagsHtml += '<span class="breadcrumb-divider">/</span>';
					currentTagsHtml += '<span><a href="/collections/{{currentCollectionLink}}/' + this.slugify(tag) + '" title="' + tag + '"><span>' + tag + '</span></a></span>';
				}
			}
			breadcrumbHtml += currentTagsHtml;
			// Build Collection Info
			breadcrumbHtml = breadcrumbHtml.replace(/{{currentCollectionLink}}/g, '/collections/' + colInfo.handle).replace(/{{currentCollectionTitle}}/g, colInfo.title);
			// Top Pagination
			breadcrumbHtml += ' <span class="boost-pfs-filter-top-pagination"></span>';
			return breadcrumbHtml;
		}
		return '';
	};

	// Call Theme function to Build additional elements for Product list
	ProductList.prototype.afterRender = function (data) {
		// Build Quick view data
		if (!data) data = this.data;
		if (boostPFSConfig.custom.quick_shop_enabled) {
			this.buildExtrasProductListByAjax(data, 'boost-pfs-quickview', function(results) {
				results.forEach(function(result) {
					var element = '';
					if (boostPFSConfig.custom.quick_shop_style == 'inline') {
						element = jQ('[data-boost-theme-quickview="'+ result.id +'"]');
						if (element.find('.js-quick-shop-link').length == 0) {
							element.append(result.quickview);
						}
					} else {
						element = jQ('[data-boost-theme-quickview="'+ result.id +'"] div.info');
						if (element.find('.js-quick-shop-link').length == 0) {
							element.append(result.quickview);
						}
					}
				});
				buildTheme();
			});
		}

		/** Start Swym integration **/
		window.SwymCallbacks = window.SwymCallbacks || [];
		window.SwymCallbacks.push(function(swat) {
			// Wrap with callback for loading without additional checks
			var products = [];
			data.forEach(function(product) {
				var image_src = Utils.getFeaturedImage(product.images_info);
				var productCopy = product;
				productCopy.featured_image = image_src;
				productCopy.price = product.price_min; // Sometimes I need to multiply the price with 100
				productCopy.compare_at_price = product.compare_at_price_min; // Sometimes I need to multiply the price with 100
				products.push(productCopy);
			});
			swat.mapShopifyProducts(products); // Product mapped data to swym layer
			swat.initializeActionButtons('.boost-pfs-filter-products'); // Buttons can now be initialized
		});
		/** End Swym integration **/

		if(document.querySelector('.custom-quickbuy__size')) {
			const allSizes = document.querySelectorAll('.custom-quickbuy__size');
			allSizes.forEach(function(size){
				size.addEventListener('click', function(evt){
					evt.preventDefault();
					selectSizeQuickbuy(evt);
					activeSelectedSize(evt);
				});
			});

			function selectSizeQuickbuy(evt) {
				const product = evt.target.closest('li').getAttribute('data-product');
				const variant = evt.target.closest('li').getAttribute('data-variant');
				const form = evt.target.closest('form');
				const input = form.querySelector('.product-select');
				
				input.setAttribute('data-productid', product);
				input.setAttribute('value', variant);
			}

			function activeSelectedSize(evt) {
				const element = evt.target;
				const wrappper = element.closest('ul');
				const allSizes = wrappper.querySelectorAll('.custom-quickbuy__size');
				allSizes.forEach(function(size){
					size.classList.remove('actived');
				});
				element.classList.add('actived');
			}
		}

		if(document.querySelector('.custom-quickbuy__wrapper')) {
			const quickBuyBtn = document.querySelectorAll('.custom-quickbuy__btn');
			quickBuyBtn.forEach(function(btn){
				btn.addEventListener('touchstart', function(evt) {
					openSizesSettings(evt);
				});

				btn.addEventListener('click', function(evt) {
					openSizesSettings(evt);
				});
			});
				

			const productLink = document.querySelectorAll('.custom-quickbuy__wrapper');
			productLink.forEach(function(link) {
				if(link.closest('a') && link.querySelector('.custom-quickbuy__btn')) {
					link.closest('a').addEventListener("touchmove", (event) => {
						if(window.innerWidth > 1180) {
							closeQuickbuyOnHover(event);
						}
					});

					link.closest('a').addEventListener("mouseleave", (event) => {
						if(window.innerWidth > 1180) {
							closeQuickbuyOnHover(event);
						}
					});
				}
			});
			
			const closeQuickbuy = document.querySelectorAll('.custom-quickbuy__close');
			closeQuickbuy.forEach(function(close){
				close.addEventListener('click', function(event) {
					event.preventDefault();
					closeQuickbuyClick(event);
				});
			});

			const detailsBtns = document.querySelectorAll('.custom-quickbuy__title-wrapper');
			detailsBtns.forEach((btn) => {
				btn.addEventListener('click', function(event) {
					event.preventDefault();
					viewMoreDetails(event);
				})
			})

			function openSizesSettings(evt) {
				evt.preventDefault();
				evt.stopPropagation();

				if(document.querySelector('.custom-quickbuy--mobile') && window.innerWidth <= 1180) {
					openMobileQuickBuy(evt);
				} else {
					openQuickBuySizes(evt);
				}
			}

			function openQuickBuySizes(evt) {
				const element = evt.target;
				const form = element.closest('form')
				const quickBuyList = form.querySelector('.custom-quickbuy__list');
				const link = quickBuyList.closest('a');
				link.style.pointerEvents = 'none';
				quickBuyList.style.display = 'block';

				if(window.innerWidth > 1180) {
					quickBuyShowAddBtn(element);	
				}
			}

			function quickBuyShowAddBtn(element) {
				const addtocart = element.closest('.custom-quickbuy__wrapper').querySelector('.add_to_cart');
				addtocart.style.display = 'block';
				element.style.display = 'none';
			}

			function quickBuyHideAddBtn(element) {
				const addtocart = element.querySelector('.add_to_cart');
				addtocart.style.display = 'none';

				if(element.querySelector('.custom-quickbuy__list')) {
					const quickbuyList = element.querySelector('.custom-quickbuy__list');
					quickbuyList.style.display = 'none';

					const quickbuyBtn = element.querySelector('.custom-quickbuy__btn');
					quickbuyBtn.style.display = 'flex';
				}
			}

			function closeQuickbuyOnHover(event) {
				const element = event.target;

				if(element.querySelector('.custom-quickbuy__list')) {
					const quickBuyWrapper = element.querySelector('.custom-quickbuy__list');
					quickBuyWrapper.style.display = 'none';
				}

				//remove selected sizes if exist
				if(element.querySelector('.custom-quickbuy__size.actived')) {
					const allSelectedSizes = element.querySelectorAll('.custom-quickbuy__size.actived');

					allSelectedSizes.forEach(function(size) {
						size.classList.remove('actived');
					})
				}

				quickBuyHideAddBtn(element);
			}

			function closeQuickbuyClick(event) {
				const element = event.target;
				const quickBuyWrapper = element.closest('.custom-quickbuy');
				const quickBuyList = quickBuyWrapper.querySelector('.custom-quickbuy__list');
				quickBuyList.style.display = 'none';

				if(quickBuyList.closest('a')) {
					const link = quickBuyList.closest('a');
					link.style.pointerEvents = 'none';
				}

				quickBuyHideAddBtn(quickBuyWrapper);

				if(element.closest('.custom-quickbuy--mobile.actived')) {
					element.closest('.custom-quickbuy--mobile').classList.remove('actived');
					document.querySelector('body').classList.remove('quickbuy-mobile-actived');
				}
			}

			function openMobileQuickBuy(evt) {
				const element = evt.target;
				const thumb = element.closest('.thumbnail');
				const mobileQuickBuy = thumb.querySelector('.custom-quickbuy--mobile');
				const allMobileQuickBuy = document.querySelectorAll('.custom-quickbuy--mobile');
				allMobileQuickBuy.forEach((quick) => {
					quick.classList.remove('actived');
				});

				document.querySelector('body').classList.add('quickbuy-mobile-actived');
				mobileQuickBuy.classList.add('actived');
				mobileQuickBuy.querySelector('.add_to_cart').style.display = 'block';
				mobileQuickBuy.querySelector('.custom-quickbuy__btn').style.display = 'none';
			}

			function viewMoreDetails(evt) {
				const element = evt.target;
				const url = element.getAttribute('data-url');

				window.location.href = url;
			}
		}
	};

	// Build Additional elements
	FilterResult.prototype.afterRender = function (data) {
		if (!data) data = this.data;
		// Remove InstantClick
		jQ(Selector.filterTree).find('a').attr('data-no-instant', '');

		// Remove product wrapper
		if (jQ(Selector.products).children().hasClass('product-list')) {
			jQ(Selector.products).children().children().unwrap();
		}

		// Build top pagination
		var totalPage = Math.ceil(data.total_product / Globals.queryParams.limit);
		var topPaginationHtml = '<span class="breadcrumb-divider">/</span> ' + (boostPFSConfig.label.breadcrumb_page).replace(/{{ current_page }}/g, Globals.queryParams.page).replace(/{{ pages }}/g, totalPage);
		jQ('.boost-pfs-filter-top-pagination').html(topPaginationHtml);
		jQ(".load-more__icon").remove();

		buildTheme();
	};

	function buildTheme() {
		if ((Shopify.theme_settings.enable_shopify_review_comments || Shopify.theme_settings.enable_shopify_collection_badges) && window.SPR) {
			SPR.registerCallbacks();
			SPR.initRatingHandler();
			SPR.initDomEls();
			SPR.loadProducts();
			SPR.loadBadges();
		}
		if (Shopify.theme_settings.show_multiple_currencies) {
			convertCurrencies();
		}
		imageFunctions.showSecondaryImage()
		Shopify.PaymentButton.init();
		productPage.init();
		if (Shopify.theme_settings.quick_shop_enabled) {
			quickShop.init();
		}
		hideNoScript();
	}

    FilterApi.beforeCall = function(eventType, eventInfo) {
      console.log('api beforecall')
        Globals.queryParams.currency = boostPFSConfig.general.current_currency.toLowerCase();
        Globals.queryParams.currency_rate = Shopify.currency.rate;
        Globals.queryParams.return_all_currency_fields = false;
    }

})(); // Add this at the end






/* Begin patch boost-010 run 2 */
Filter.prototype.beforeInit=function(){var t=this.isBadUrl();t&&(this.isInit=!0,window.location.href=window.location.pathname)},Filter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var n=0;n<t.length;n++){var i=t[n],r=(i.match(/</g)||[]).length,a=(i.match(/>/g)||[]).length,o=(i.match(/alert\(/g)||[]).length,h=(i.match(/execCommand/g)||[]).length;if(r>0&&a>0||r>1||a>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
